<template>
  <div id="app">
    <Header :user-info="userInfo"  v-if="visibleheader" @headerClick="showLoginDialog" ref="header"/>
    <router-view :style="otherPath ? '' :'flex: 1;'" @headerClick="showLoginDialog" @buyPath="buyPath"/>
    <Footer v-if="visibleheader"/>

    <!--登录-->
    <el-dialog
      :visible.sync="showLogin"
     custom-class="loginWid"
      append-to-body
      top="5px"
      @close="closeLoginDialog"
    >
      <Login @loginClick="getLoginResult" />
    </el-dialog>

    <!--跳转引导-->
    <el-dialog
      :visible.sync="showToGo"
      custom-class="loginWid"
      append-to-body
      fullscreen
      :show-close="false"
      @close="closeLoginDialog"
    >
      <div style="display: flex; justify-content: center; align-items: center">
        <img style="width: 100vw" src="../assets/imgs/openWeb.png"/>
      </div>
    </el-dialog>

  </div>
</template>
<script>
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Login from '@/components/Login';
import { getUserInfo } from '../utils/api'
export default {
  name: "App",
  data() {
    return {
      otherPath: false,
      showLogin: false,
      showToGo: false,
      curViewName: "PhotoSir",
      isLogin: localStorage.getItem("isLogin") || false,
      userInfo: JSON.parse(localStorage.getItem("UserInfo")) || {
        headerUrl: "",
        nickname: "",
        isSVip: false,
        grade: ""
      },
      visibleheader: true,
    };
  },
  components: {
    Header,
    Footer,
    Login
  },
  watch: {
    '$route':'isWeChat'
  },
  created(){
    this.isWeChat()
    if (this.$route.query.token) {
      this.$cookies.set('token', this.$route.query.token)
      this.getUserInfo();
    }
    if(localStorage.getItem('isLogin')){
      this.getUserInfo();
    }
  },

  methods: {
    // 使用兄弟组件方法
    buyPath(name){
        this.$refs.header.onClickItemListener(name)
    },
    changeCurViewName(name) {
      this.curViewName = name;
      // 调用子视图函数
      this.$refs.header.onClickItemListener(name);
    },

    hideheader() {
      this.visibleheader = false;
    },

    showLoginDialog() {
      this.isLogin = false;
      this.userInfo = {
        headerUrl: "",
        nickname: "",
        isSVip: false,
        grade: ""
      };
      this.showLogin = true;
    },

    closeLoginDialog() {
      this.showLogin = false;
      localStorage.setItem("isLogin", this.isLogin);
    },

    getLoginResult(data) {
      this.showLogin = false;
      this.isLogin = data.isLogin;
      let userInfo = {
        headerUrl: data.userInfo.headimgurl,
        nickname: data.userInfo.nickName,
        isSVip: data.userInfo.isSvip === 1,
        grade: data.userInfo.grade
      };
      this.isLogin = data.isLogin;
      this.userInfo = userInfo;
      localStorage.setItem("isLogin", data.isLogin);
      localStorage.setItem("UserInfo", JSON.stringify(userInfo));
    },

    //获取用户信息
    getUserInfo() {
       let formData = new FormData();
      getUserInfo(formData).then(res=>{
          if (res.data.code === 0) {
            this.showLogin = false;
            this.isLogin = true;
            let userInfo = {
              headerUrl: res.data.data.headimgurl,
              nickname: res.data.data.nickName,
              isSVip: res.data.data.isSvip === 1,
              grade: res.data.data.grade
            };
            this.userInfo = userInfo;
            localStorage.setItem("isLogin", this.isLogin);
            localStorage.setItem("UserInfo", JSON.stringify(userInfo));
          }else {
            localStorage.setItem("isLogin", false);
            if(res.data.code  == 12){
              this.$message.error(res.data.result);
              this.$cookies.set('token', '') // 清除本地token
              window.localStorage.clear() // 清除本地所有缓存信息
            }
          }
          let newQuery = JSON.parse(JSON.stringify(this.$route.query))
          delete newQuery.token
          this.$router.replace({ query: newQuery })
      })
    },

    //微信浏览器判断
    isWeChat(){
      this.otherPath = this.$route.path.indexOf('Lenovo') !== -1;//联想页
      let ua = window.navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) == 'micromessenger') {
        if(this.$route.path.indexOf('Buy') !== -1){
          this.showToGo = true;
        }else {
          this.showToGo = false;
        }
        return true;
      } else {
        return false;
      }
    },
  },
   mounted() {
    window.dataLayer = window.dataLayer || [];
      function gtag(){
       dataLayer.push(arguments);
      }
     gtag('js', new Date());
     gtag('config', 'G-RFBJDTX60Q');
  },
};
</script>

<style>
.loginWid {
  width: 660px;
}
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  display: flex;
  flex-direction: column;
  height: 100%;
}
@media (max-width: 740px) {
.loginWid {
  width: 100% !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/layout.vue